<template>
  <div class="hl-wid ww3 adm-list">
    <ul class="tab-like">
      <li class="head">
        <ul>
          <li class="title" v-on:click.prevent="toggleSort('title')">
            <span>Title</span>
          </li>
        </ul>
      </li>
      <li v-for="(item, ii) in items">
        <ul>
          <li class="title"><router-link :to="{name: 'content', params: {id: item.id}}">{{ item.title }}</router-link></li>
          <li class="type">&nbsp;</li>
          <li class="language">&nbsp;</li>
          <li class="author">&nbsp;</li>
          <li class="date">&nbsp;</li>
          <li class="remove"><a href="" v-on:click.prevent="remove(ii)">remove</a></li>
          <router-link class="link-full" :to="{name: 'content', params: {id: item.id}}"></router-link>
        </ul>
      </li>
      <li v-if="!item.videos.length">
        (no videos)
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: ["item"],
  data: ()=>({
    items: [],
  }),
  async created() {
    var where={id: ["IN ("+this.item.videos.join(",")+")"]}
    var items2={};
    this.items=[];
    for(var item of (await api.list("Video", where)).items)
      items2[item.id]=item;
    for(var item of this.item.videos)
      this.items.push(items2[item]);
  },
  methods: {
    async remove(index) {
      this.item.videos.splice(index, 1);
      this.items.splice(index, 1);
      await api.update("Playlist", this.item.id, {videos: this.item.videos});
    },
  },
}
</script>
